<template>
  <footer class="footer">
    <div class="footer__top">
      <div class="footer__item">
        <img class="footer__item-icon" src="../assets/icon/phone.png" alt="" />
        <div class="footer__item-text">188-1853-9314</div>
      </div>
      <div class="footer__item">
        <img class="footer__item-icon" src="../assets/icon/email.png" alt="" />
        <div class="footer__item-text">
          zhanshiyu@ippmaster.com&nbsp;&nbsp;|&nbsp;&nbsp;zhangenhui@ippmaster.com
        </div>
      </div>
      <div class="footer__item">
        <img
          class="footer__item-icon"
          src="../assets/icon/address.png"
          alt=""
        />
        <div class="footer__item-text">
          深圳市南山区粤海街道高新社区科技南路18号深圳湾科技生态园12栋B4座603室
        </div>
      </div>
    </div>
    <div class="footer__hr"></div>
    <div class="footer__bottom">
      粤ICP备2023076493号
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer"
};
</script>

<style lang="less" scoped>
.footer {
  background: #252525;
  text-size-adjust: none;
  font-family: PingFang SC;

  &__top {
    box-sizing: border-box;
    padding: 0.43rem 0 0.39rem 0.67rem;
  }

  &__item {
    display: flex;
    align-items: center;

    &:nth-of-type(n + 2) {
      margin-top: 0.36rem;
    }

    &-icon {
      width: 0.29rem;
      height: 0.29rem;
      margin-right: 0.16rem;
      object-fit: contain;
    }

    &-text {
      text-size-adjust: none;
      font-size: 0.22rem;
      font-weight: 300;
      line-height: 0.36rem;
      color: #ffffff;
    }
  }

  &__hr {
    width: 100vw;
    height: 1px;
    background-color: #fff;
    opacity: 0.41;
  }

  &__bottom {
    padding: 0.35rem 0 0.39rem 0;
    text-size-adjust: none;
    text-align: center;
    font-size: 0.22rem;
    font-weight: 100;
    line-height: 0.36rem;
    color: #ffffff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue